import enums from "./enums";
import cookies from "./cookies";
import storage from "./storage";

//兼容cookie于sessionStorage,防止某些情况cookie无法使用
const sessionMap = enums.sessionMap;
const storageStr = "session_";

function getAllSessionStorage() {
  let obj = {};
  for (let storageKey in window.sessionStorage) {
    if (storageKey.startsWith(storageStr)) {
      const k2 = storageKey.replace(storageStr, "");
      obj[k2] = dsf.storage.session.get(storageKey);
    }
  }
  return obj;
}
export default {
  get(key) {
    if (sessionMap[key]) {
      key = sessionMap[key];
    }
    const { cookies, storage } = dsf;
    if (key) {
      return cookies.get(key) || storage.session.get(`${storageStr}${key}`) || "";
    } else {
      let result = cookies.get(key);
      if (dsf.isEmptyObject(result)) {
        result = getAllSessionStorage();
      }
      return result;
    }
  },
  set(key, value) {
    if (sessionMap[key]) {
      key = sessionMap[key];
    }
    const { cookies, storage } = dsf;
    cookies.set(key, value);
    storage.session.set(`${storageStr}${key}`, value);
    return value;
  },
  remove(key) {
    if (sessionMap[key]) {
      key = sessionMap[key];
    }
    cookies.remove(key);
    storage.session.remove(`${storageStr}${key}`);
  },
  has(key) {
    if (key) {
      const result = this.get(key);
      return result === "" || dsf.isUnDef(result) ? false : true;
    }
    return false;
  }
};
